export default function checkIfEdge() {
  return (
    typeof window !== 'undefined' &&
    window.navigator &&
    window.navigator.userAgent &&
    window.navigator.userAgent.indexOf('Edge') > -1
  );
}
